import { useEffect } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useXingUserFeatures } from '@xing-com/crate-hooks-use-xing-user-features';

import { trackPage } from '../../utils/tracking';

const useTrackPage = ({ pageName }: $TSFixMe) => {
  const { isBrandManagerEditor } = useXingUserFeatures();

  const { isLoggedIn } = useLoginState();

  useEffect(() => {
    if (!isLoggedIn || isBrandManagerEditor !== undefined) {
      const trackingParams = isLoggedIn
        ? {
            PropContextDimension3: isBrandManagerEditor
              ? 'companies_editor'
              : 'companies_user',
          }
        : {};

      trackPage(pageName, {
        ...trackingParams,
      });
    }
  }, [isBrandManagerEditor, isLoggedIn, pageName]);
};

export { useTrackPage };
